import Vue from "vue";
/**
 * Converts a number string to currency format.
 * Example: 1000000 => 1.000.000
 *
 * @param  {String} str the string to convert
 * @return {String}
 */
Vue.filter("currency", str => {
  return str && !isNaN(str)
    ? new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 0
      }).format(
        (str / 1)
          .toFixed(0)
          .replace(".", ",")
          .toString()
      )
    : "-";
});

Vue.filter("currencyNol", str => {
  return str && !isNaN(str)
    ? new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 0
      }).format(
        (str / 1)
          .toFixed(0)
          .replace(".", ",")
          .toString()
      )
    : "0";
});

Vue.filter("currencyNew", str => {
  return str && !isNaN(str)
    ? new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 2
      }).format(str)
    : "0";
});

Vue.filter("threeDots", str => {
  return (
    str &&
    !isNaN(str) &&
    new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 3
    }).format((str / 1).replace(".", ",").toString())
  );
});

Vue.filter("number", str => {
  return str ? str.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : "0";
});

Vue.filter("percentage", str => {
  return str && !isNaN(str) && (str * 100).toFixed(2);
});

Vue.filter("percentageSymbol", str => {
  return str && !isNaN(str) && `${(str * 100).toFixed(2)} %`;
});

Vue.filter("checkNumber", str => {
  if (str === null) return;

  return str + "%";
});
